import React, {useRef, useState, useEffect} from 'react'
import {useMultiStyleConfig, StackProps, TextProps, Divider, VStack, Box} from '@chakra-ui/react'
import {BasketProductModel, MiniCartPreferences} from '_types'
import {useCurrentBasket} from '_customHooks'
import {MinicartProduct, Loader, MinicartFooter} from '_uiComponents'
import {useLoader} from '_context'

const MinicartBody = ({minicartPreferences}: {minicartPreferences: MiniCartPreferences}) => {
    const styles = useMultiStyleConfig('MinicartBody') as Record<string, StackProps | TextProps>
    // Read-only consumer: light useCurrentBasket (same query, no mutation hooks/effects).
    const {data: basket} = useCurrentBasket()
    const {isLoaderShowing} = useLoader()
    const products = (basket?.productItems?.slice()?.reverse() ?? []) as Array<BasketProductModel>

    const containerRef = useRef<HTMLDivElement>(null)
    const [footerFixed, setFooterFixed] = useState(true)

    useEffect(() => {
        const checkHeight = () => {
            if (containerRef.current) {
                const height = containerRef.current.offsetHeight
                setFooterFixed(height >= 500)
            }
        }

        checkHeight()

        // Optional: aggiorna al resize della finestra
        window.addEventListener('resize', checkHeight)
        return () => window.removeEventListener('resize', checkHeight)
    }, [products, isLoaderShowing]) // Ricalcola se cambiano prodotti o loader

    return (
        <VStack {...styles.wrapper} data-testid="minicart-body" ref={containerRef}>
            {isLoaderShowing && <Loader />}
            {products?.map((product, index) => (
                <React.Fragment key={`minicart-product-${product.productId}`}>
                    <MinicartProduct product={product} />
                    {index < products.length - 1 && <Divider aria-orientation={undefined} />}
                </React.Fragment>
            ))}
            <Box w={'100%'} pt={'320px'} hidden={!footerFixed}></Box>
            <MinicartFooter minicartPreferences={minicartPreferences} footerFixed={footerFixed} />
        </VStack>
    )
}

export {MinicartBody}
